"use client";

import type React from "react";
import { createContext, useContext, useState } from "react";

type Message = {
  translationFieldName: string;
  translationChunkName: string;
  type: "error" | "success" | "warning";
};

interface InfoMessageContextValue {
  message: Message | null;
  handleSetMessage: (msg: Message | null) => void;
}

const InfoMessageContext = createContext<InfoMessageContextValue>({
  message: null,
  handleSetMessage: () => {
    // Default no-op implementation - will be replaced by provider
  },
});

export function InfoMessageProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [message, setMessage] = useState<Message | null>(null);

  const handleSetMessage = (msg: Message | null) => {
    setMessage(msg);
  };

  return (
    <InfoMessageContext.Provider value={{ message, handleSetMessage }}>
      {children}
    </InfoMessageContext.Provider>
  );
}

export const useInfoMessage = () => useContext(InfoMessageContext);
